import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoLogin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 286,
	height: 53,
	viewBox: "0 0 286 53",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M52.7071 18.2839C52.7071 7.54207 43.0024 0 29.2919 0H0V52.3378H17.2722V36.5679H22.6142L35.5241 52.3378H55.2L40.5989 34.587C48.0778 31.616 52.7071 25.7498 52.7071 18.2839ZM27.8671 23.1596H17.2722V13.4082H27.8671C31.963 13.4082 34.9007 15.4652 34.9007 18.2839C34.9007 21.1026 31.963 23.1596 27.8671 23.1596Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.9125 52.3378H102.241V35.1204L125.732 0H106.707L93.5769 21.255L81.1613 0H61.332L84.9125 35.1204V52.3378Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M187.067 52.3378V0H164.671C143.674 0 128.801 10.8942 128.801 26.2071C128.801 41.5197 143.674 52.3378 164.671 52.3378H187.067V52.3378ZM146.299 26.2071C146.299 18.7409 152.773 13.4082 161.871 13.4082H170.095V38.9295H161.871C152.773 38.9295 146.299 33.673 146.299 26.2071Z",
			fill: "#40E098"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.469 52.3378H251.469V39.158H221.606V32.2256H248.807V19.0458H221.606V13.1797H251.469V0H205.469V52.3378Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M285.201 39.2529H269.867V52.3374H285.201V39.2529Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLogoLogin);
export { ForwardRef as ReactComponent };
